/* np-home – <np-product-rail> for sections/np-home-products: prev/next arrows for the visible row
   and accessible tabs (arrow keys, Home/End) that also update the "Se alle" link. */
if (!customElements.get('np-product-rail')) {
	class NpProductRail extends HTMLElement {
		connectedCallback() {
			this.prev = this.querySelector('[data-rail-prev]');
			this.next = this.querySelector('[data-rail-next]');
			this.link = this.querySelector('[data-rail-link]');
			this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));

			this.prev?.addEventListener('click', () => this.scrollBy(-1));
			this.next?.addEventListener('click', () => this.scrollBy(1));
			this.onScroll = () => this.updateArrows();
			this.bindTrack();

			this.tabs.forEach((tab, i) => {
				tab.addEventListener('click', () => this.select(i));
				tab.addEventListener('keydown', (event) => {
					const keys = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: this.tabs.length - 1 };
					if (!(event.key in keys)) return;
					event.preventDefault();
					const j = (keys[event.key] + this.tabs.length) % this.tabs.length;
					this.select(j);
					this.tabs[j].focus();
				});
			});

			document.addEventListener('shopify:block:select', (event) => {
				const i = this.tabs.indexOf(event.target);
				if (i > -1) this.select(i);
			});
			window.addEventListener('resize', () => this.updateArrows(), { passive: true });
		}

		get track() {
			const panel = this.querySelector('.np-rail__panel:not([hidden])');
			return panel ? panel.querySelector('[data-rail-track]') : null;
		}

		bindTrack() {
			if (this.boundTrack) this.boundTrack.removeEventListener('scroll', this.onScroll);
			this.boundTrack = this.track;
			if (this.boundTrack) this.boundTrack.addEventListener('scroll', this.onScroll, { passive: true });
			this.updateArrows();
		}

		scrollBy(direction) {
			const track = this.track;
			if (!track) return;
			track.scrollBy({
				left: direction * track.clientWidth * 0.9,
				behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
			});
		}

		updateArrows() {
			const track = this.track;
			if (!track || !this.prev || !this.next) return;
			const max = track.scrollWidth - track.clientWidth - 2;
			this.prev.disabled = track.scrollLeft <= 2;
			this.next.disabled = track.scrollLeft >= max;
			this.classList.toggle('np-rail--static', max <= 0);
		}

		select(index) {
			this.tabs.forEach((tab, i) => {
				const on = i === index;
				tab.setAttribute('aria-selected', on ? 'true' : 'false');
				tab.tabIndex = on ? 0 : -1;
				const panel = this.querySelector('#' + tab.getAttribute('aria-controls'));
				if (panel) panel.hidden = !on;
				if (on && this.link && tab.dataset.url) this.link.href = tab.dataset.url;
			});
			this.bindTrack();
		}
	}
	customElements.define('np-product-rail', NpProductRail);
}
